import Apiconfig from 'configurations';

export const AUTH_CONFIG = {
  domain: "rake-dev.auth0.com",
  clientId: "M2OzMbKkRs3XFE7O3bWAiC43dwmylnOg",
  callbackUrl: Apiconfig.baseUrl + "/api/auth/zero/callback"
};
